import React, { Component } from "react"

import "./userProfile.scss"
import { bindActionCreators } from "redux"
import {
  addUserToBlacklist,
  getData,
  removeUserFromBlacklist,
} from "../../../../library/store/actions/creators/authCreators"
import { connect } from "react-redux"
import { Route, withRouter } from "react-router-dom"
import UserProfileHeader from "./userProfileHeader/userProfileHeader"
import UserProfileContent from "./userProfileContent/userProfileContent"
import {
  getPerson,
  resetPerson,
} from "../../../../library/store/actions/creators/personCreators"
import {
  acceptFriendRequest,
  cancelFriendRequest,
  declineFriendRequest,
  deleteFriend,
  sendFriendRequest,
} from "../../../../library/store/actions/creators/friendsCreators"
import { withSnackbar } from "notistack"
import PostModal from "../../feed/postModal/postModal"
import * as routes from "../../../../library/constants/routes"
import { clearPostsList } from "../../../../library/store/actions/creators/postsCreators"
import NotFound from "../../../../components/notFound/notFound"
import UserError from "../userError/userError"
import Loader from "../../../../components/ui/loader/loader"
import getErrorText from "../../../../library/constants/errorTypes"
import Stub from "../../../../components/stub"
import BlacklistModal from "../../../../components/complaints/blacklistModal"
import BookMeetModal from "../../../bookMeet/bookMeetModal"
import BookMeetProvider from "../../../bookMeet/bookMeetContext"

class UserProfile extends Component {
  state = {
    type: "other-profile",
    userInfo: undefined,
    isPostModal: false,
    dataReceived: false,
    error404: false,
    userBlocked: false,
    userDeleted: false,
    currentUserDeleted: false,
    currentUserBlocked: false,
    currentUserBlacklisted: false,
    isContentVisible: true,
    userBlacklisted: false,
    showBlacklistModal: false,
  }

  async componentDidMount() {
    const { userId } = this.props.match.params
    const { userData } = this.props.auth
    const id = parseInt(userId)

    try {
      if (userData.id !== id) {
        await this.props.getPerson(userData.token, id)
        this.setState({
          type: "other-profile",
          userInfo: this.props.person.personData,
          userDeleted: this.props.person.personData.deleted,
          userBlocked: this.props.person.personData.blocked,
          userBlacklisted: this.props.person.personData.is_blocked,
          isContentVisible: !this.props.person.personData.is_blocked,
          currentUserBlacklisted: this.props.person.personData.is_blocking,
          dataReceived: true,
        })
      } else {
        await this.props.getData(userData.token, userData.id)
        this.setState({
          type: "my-profile",
          userInfo: this.props.auth.userData,
          currentUserBlocked: this.props.auth.userData.blocked,
          userBlocked: this.props.auth.userData.deleted,
          isContentVisible: true,
          dataReceived: true,
        })
      }
    } catch ({ error }) {
      if (error.code === 20100) {
        return this.setState({ error404: true })
      }

      if (error.code === 20005) {
        return this.setState({ currentUserDeleted: true })
      }

      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.match.params.userId !== prevProps.match.params.userId) {
      this.setState({ dataReceived: false })
      const {
        match: {
          params: { userId },
        },
        auth: { userData },
      } = this.props
      const id = parseInt(userId)

      try {
        if (userData.id !== id) {
          await this.props.getPerson(userData.token, id)
          this.setState({
            type: "other-profile",
            userInfo: this.props.person.personData,
            userDeleted: this.props.person.personData.deleted,
            userBlocked: this.props.person.personData.blocked,
            userBlacklisted: this.props.person.personData.is_blocked,
            isContentVisible: !this.props.person.personData.is_blocked,
            currentUserBlacklisted: this.props.person.personData.is_blocking,
            error404: false,
            dataReceived: true,
          })
        } else {
          await this.props.getData(userData.token, userData.id)
          this.setState({
            type: "my-profile",
            userInfo: this.props.auth.userData,
            userDeleted: this.props.auth.userData.deleted,
            currentUserBlocked: this.props.auth.userData.blocked,
            isContentVisible: true,
            error404: false,
            dataReceived: true,
          })
        }
      } catch ({ error }) {
        if (error.code === 20100) {
          return this.setState({ error404: true })
        }

        if (error.code === 20005) {
          return this.setState({ currentUserDeleted: true })
        }

        this.props.enqueueSnackbar(getErrorText(error.code), {
          variant: "error",
        })
      }
    }
  }

  componentWillUnmount() {
    if (this.state.type === "other-profile") {
      this.props.resetPerson()
      this.props.clearPostsList("person")
    } else {
      this.props.clearPostsList("my")
    }
  }

  onBlacklistModalOpen = () => {
    this.setState({ showBlacklistModal: true })
  }

  onBlacklistModalClose = () => this.setState({ showBlacklistModal: false })

  addToBlacklist = async () => {
    const { id, first_name, last_name } = this.state.userInfo

    try {
      console.log(id, first_name, last_name)
      await this.props.addUserToBlacklist({
        user: {
          id,
          first_name,
          last_name,
        },
      })

      this.setState({ isContentVisible: false, userBlacklisted: true })
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  removeFromBlacklist = async () => {
    try {
      await this.props.removeUserFromBlacklist({
        user_id: this.state.userInfo.id,
      })
      // console.log('await this.props.removeUserFromBlacklist({user_id: this.state.userInfo.id});');

      this.setState({ isContentVisible: true, userBlacklisted: false })
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  showUserContent = () => this.setState({ isContentVisible: true })
  hideUserContent = () => this.setState({ isContentVisible: false })

  render() {
    const { userInfo, userDeleted, userBlocked, error404, dataReceived } =
      this.state

    if (error404) {
      return <NotFound entity="User" />
    }

    if (userBlocked || userDeleted || this.state.currentUserBlacklisted) {
      return <UserError user={userInfo} />
    }

    if (dataReceived) {
      return (
        <div className="profile-container">
          <UserProfileHeader
            type={this.state.type}
            userInfo={this.state.userInfo}
            onBlacklistModalOpen={this.onBlacklistModalOpen}
            isContentVisible={this.state.isContentVisible}
            removeFromBlacklist={async () => {
              await this.removeFromBlacklist()
              this.setState({ userBlacklisted: false })
            }}
            showUserContent={this.showUserContent}
            hideUserContent={this.hideUserContent}
            isBlacklisted={this.state.userBlacklisted}
          />

          {this.state.isContentVisible ? (
            <UserProfileContent
              type={this.state.type}
              userInfo={this.state.userInfo}
              {...this.props}
            />
          ) : (
            <Stub text={`${this.state.userInfo.first_name} is blacklisted`} />
          )}

          {/*<UserBlacklistContextProvider userBlacklisted={userBlacklisted}>*/}
          {/*    {({*/}
          {/*          isContentVisible,*/}
          {/*          isBlacklisted,*/}
          {/*          onBlacklistModalOpen,*/}
          {/*          removeFromBlacklist,*/}
          {/*          showUserContent,*/}
          {/*          hideUserContent,*/}
          {/*      }) => {*/}
          {/*        return (*/}
          {/*            <>*/}
          {/*                <UserProfileHeader*/}
          {/*                    type={this.state.type}*/}
          {/*                    userInfo={this.state.userInfo}*/}
          {/*                    onBlacklistModalOpen={() => onBlacklistModalOpen(this.state.userInfo)}*/}
          {/*                    isContentVisible={isContentVisible}*/}
          {/*                    removeFromBlacklist={async () => {*/}
          {/*                        await removeFromBlacklist(this.state.userInfo.id);*/}
          {/*                        this.setState({userBlacklisted: false});*/}
          {/*                    }}*/}
          {/*                    showUserContent={showUserContent}*/}
          {/*                    hideUserContent={hideUserContent}*/}
          {/*                    isBlacklisted={userBlacklisted || isBlacklisted}*/}
          {/*                />*/}

          {/*                {(!userBlacklisted && !isBlacklisted) || isContentVisible ? (*/}
          {/*                    <UserProfileContent type={this.state.type}*/}
          {/*                                        userInfo={this.state.userInfo} {...this.props}/>*/}
          {/*                ) : (*/}
          {/*                    <Stub text={`${this.state.userInfo.first_name} is blacklisted`} />*/}
          {/*                )}*/}
          {/*            </>*/}
          {/*        );*/}
          {/*    }}*/}
          {/*</UserBlacklistContextProvider>*/}

          <Route
            path={routes.USER_POST}
            render={(props) => (
              <PostModal
                {...props}
                userInfo={this.state.userInfo}
                type={this.state.type}
              />
            )}
          />

          <Route
            path={routes.BOOK_MEET_AUTHORIZED}
            render={(props) => (
              <BookMeetProvider>
                <BookMeetModal {...props} />
              </BookMeetProvider>
            )}
          />

          {this.state.showBlacklistModal && (
            <BlacklistModal
              open={this.state.showBlacklistModal}
              user={this.state.userInfo}
              handleClose={this.onBlacklistModalClose}
              onAddToBlacklist={this.addToBlacklist}
            />
          )}
        </div>
      )
    } else {
      return <Loader />
    }
  }
}

const mapStateToProps = ({ auth, person, friends, posts }) => ({
  auth,
  person,
  friends,
  posts,
})
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getData,
      getPerson,
      resetPerson,
      clearPostsList,
      sendFriendRequest,
      cancelFriendRequest,
      acceptFriendRequest,
      declineFriendRequest,
      deleteFriend,
      addUserToBlacklist,
      removeUserFromBlacklist,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withSnackbar(UserProfile)))
